import tick from "../../assets/tasks/fluent-mdl2_completed-solid.svg";
import cancel from "../../assets/tasks/material-symbols_cancel.svg";
import addpdf from "../../assets/tasks/Vector (3).svg";
import { Edit } from "@mui/icons-material";
import Addnote from "../Modals/Addnote";
import { useState } from "react";
import dayjs from "dayjs";
import Updatenote from "../Modals/Updatenote";
import addpdforange from "../../assets/tasks/material-symbols-light_note-add-sharp.svg";
import api from "../../api/api";
import TasksModal from "../Modals/TasksModal";
import CheckIcon from "@mui/icons-material/Check";
import ScheduleModal from "../Modals/ScheduleModal";
import DoctorP from "../../assets/tasks/DoctorP.svg";
import DoctorF from "../../assets/tasks/DoctorP.svg";
import Alertsgraphs from "../Modals/Alertsgraphs";
import { humanicon } from "../../utils/svgs/svgcode";
import ToastMessage from "../../utils/mui/righttoptoast";
import { useSelector } from "react-redux";
import { flag } from "../svgs";
const MiniCards = ({
  task,
  markAsComplete,
  markAsFlag,
  markAscancel,
  trigger,
  totalOrders,
  loginuser,
  dob,
  insuranceName,
  handleconfirmScheduleClick,
  scheduleStates,
  selectedOrder,
  setSelectedOrder,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalType, setModalType] = useState(null);
  const [isToday, setIsToday] = useState("");
  const [openTasks, setOpenTasks] = useState(false);
  const [scheduleConfirmationOpen, setScheduleConfirmationOpen] =
    useState(false);
  // const [selectedOrder, setSelectedOrder] = useState(null);
  const [isCompletedOrCancelled, setIsCompletedOrCancelled] = useState(false);
  let firstName = localStorage.getItem("firstname");
  let lastName = localStorage.getItem("lastname");
  const userConfig = useSelector((state) => state.userconfig);
  const [isAlertModal, setIsAlertModal] = useState(false);
  const [selectedAlert, setSelectedAlert] = useState(null);
  const [openToast, setOpenToast] = useState(false);
  const [flagOption, setFlagOption] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const taskscreenprev = useSelector((state) => state.userPrivileges.taskrpm);
  const [toastSeverity, setToastSeverity] = useState("success");
  const handleToastClose = () => {
    setOpenToast(false);
  };
  const handleAlertOpenModal = (order) => {
    setSelectedAlert(order); // Store the selected patient ID
    setIsAlertModal(true); // Open the modal
  };
  const handleAlertCloseModal = () => {
    setIsAlertModal(false); // Close the modal
  };

  const fullName = `${firstName} ${lastName}`;

  const handleCompleteClick = (task) => {
    markAsComplete([task.id.toString()], task);
    setIsCompletedOrCancelled(true); // Step 2: Update the state when a button is clicked
  };

  const handleCancelClick = (task) => {
    markAscancel([task.id.toString()], task);
    setIsCompletedOrCancelled(true); // Step 2: Update the state when a button is clicked
  };

  const opentaskModal = () => {
    setOpenTasks(true); // Set openTasks to true when the element is clicked
  };

  const closetaskModal = () => {
    setOpenTasks(false); // Set openTasks to false when the closeModal function is called
  };
  // Function to open the modal
  const openModal = () => {
    // Set modal type based on whether `order.notes` exists
    if (task.order_notes) {
      setModalType("update");
    } else {
      setModalType("add");
    }
    setIsModalOpen(true);
  };
  let user = localStorage.getItem("user");

  const handleScheduleClick = (order) => {
    setSelectedOrder(order); // Set the selected order for confirmation
    setScheduleConfirmationOpen(true); // Open the confirmation modal
  };
  const closeScheduleConfirmationModal = () => {
    setScheduleConfirmationOpen(false);
    setSelectedOrder(null);
  };

  // Function to close the modal
  const closeModal = () => setIsModalOpen(false);
  const percentage = 100; // Set your percentage value here

  // Styles for the circular progress bar and small circle with percentage text
  const circleStyle = {
    background: `conic-gradient(#E17954B2 ${percentage * 3.6}deg, #EDEDED ${
      percentage * 3.6
    }deg)`,
  };

  // console.log('orders',task)
  const getOrderStatusColor = (status) => {
    switch (status) {
      case "CANCELLED":
        return "bg-red-500"; // Red for cancelled
      case "INFO":
        return "bg-blue-500"; // Blue for info
      case "CREATED":
        return "bg-yellow-500"; // Yellow for created
      case "COMPLETED":
        return "bg-green-500"; // Green for completed
      default:
        return "bg-red-500"; // Default gray if status is unknown
    }
  };

  const cardShadowClass =
    totalOrders.length > 1 ? " shadow-[0_0_8px_rgba(225,121,84,0.4)]" : "";

  const orders = task.orders || [];
  // console.log('Task',task)
  return (
    <div
      key={task.id}
      className={`bg-white rounded-xl  ${cardShadowClass}  cursor-pointer  p-4 md:p-4 flex flex-col items-start gap-5 w-full min-h-[300px] min-w-[300px] max-w-[336px] h-auto relative m-[5px]`}
    >
      <button
        type="button"
              onClick={() =>    markAsFlag([task.id.toString()], task)}
        className={`absolute bottom-3 right-[80px] focus:outline-none focus:ring-0 focus:ring-offset-0 focus-visible:outline-none
        ${task?.status=== "FLAGGED" ? "text-[#E17954]" : "text-gray-500"}`}
      >
        {flag}
      </button>
      {/* Circle element */}
      <div className="flex w-full items-center">
        <div className="flex items-center">
          <div className="relative flex justify-center items-center w-[65px] h-[65px]">
            <div
              className={`relative flex justify-center items-center w-[65px] h-[65px] rounded-full ${
                task.is_flagged ? "bg-[#E17954B2]" : "bg-[#C4C4C4]"
              }`}
            >
              <div className="flex justify-center items-center w-[55px] h-[55px] bg-[#FAFAF9] rounded-full">
                <div className="flex justify-center items-center w-[45px] h-[45px] bg-[#C4C4C4] rounded-full">
                  <img
                    src={`/cloud-assets/chim/public/assets/images/profilepictures/${task.patientid}.png`}
                    alt="profile"
                    onError={(e) =>
                      (e.target.src =
                        "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADhCAMAAAAJbSJIAAAAM1BMVEXk5ueutLeqsbTn6eqpr7PJzc/j5ebf4eLZ3N2wtrnBxsjN0NLGysy6v8HT1tissra8wMNxTKO9AAAFDklEQVR4nO2d3XqDIAxAlfivoO//tEOZWzvbVTEpic252W3PF0gAIcsyRVEURVEURVEURVEURVEURVEURVEURVEURVEURflgAFL/AirAqzXO9R7XNBVcy9TbuMHmxjN6lr92cNVVLKEurVfK/zCORVvW8iUBnC02dj+Wpu0z0Y6QlaN5phcwZqjkOkK5HZyPAjkIjSO4fIdfcOwFKkJlX4zPu7Ha1tIcwR3wWxyFhRG6g4Je0YpSPDJCV8a2Sv2zd1O1x/2WMDZCwljH+clRrHfWCLGK8REMiql//2si5+DKWKcWeAGcFMzzNrXC/0TUwQ2s6+LhlcwjTMlYsUIQzPOCb7YBiyHopyLXIEKPEkI/TgeuiidK/R9FniUDOjRDpvm0RhqjMyyXNjDhCfIMYl1gGjIMIuYsnGEYRMRZOMMunaLVwpWRW008v6fYKDIzxCwVAeNSO90BJW6emelYBRF/kHpYGVaoxTDAaxOFsfP9y8hpJ4xd7gOcij7JNGQ1EYFgkPJa1jQEiYZXRaRINKxSDUW9n+FT82lSKadkiru9/4XPqSLWOekGPoY05TAvLm9orm+YWuwHoBHkZKijNBJGmeb61eL6Ff/6q7bLr7yvv3vKGhpDRjvgjGaPz+gUg6YgcvpyAR2FIZ9U6nEEyZRTovmEU32KichpGn7C17XrfyH9gK/c0CMP05HZIM2uf9sEveizKveBy9/6Qt7o89ne33D525cfcIMW6ab+TMEukQbQbu+xu7X3A9bChmWaCeAkG17bpntwXgWxHaMzGPmUaR5dQZiKqRVeUZ3047fi3nAu28h4CHxCsZAgmEH8Y27jJAhm8c+5RQzRQNVGhVFSfxOYIjp/pP7RxzjevYXVGf4eLt+BJ1vCuLuLkrgABgCGXZ2wik5uty+oBvNirI6mkzhAf4Gsb58Hcm67Jzd+KwD10BYPLL3e0MjvKrgAULnOfveF/O4N2Xb9BZom3gJes3F9X5Zze8/6Yt09b4CrqsEjUv8oFBaR2rl+6CZr2xVrp24o/WitBKuGrrpl1+bFkmK2qXTON4VpbdfLa7o7y/WdLxG7lm2Lqh2clOwTegbvc/vj2U78CwhA87Bn8G5Nk3eOb0Nsr9flz3sG78UUtue4kpv1xvjg3TMay62BMlTlP+vrOMnJsRmt/ze0jsfkPPYdAH57hK+34PeOyc8XIXu5xT2HsUkdZz+adwg8HGFfQ3K5jtDvbUiO4Di9/ywHGrL88pDizZ++oTp+an+SMX/ndymUCwmHMdO7yuOx83pUx/eEMU0AvxWndwgidAqOZ8ypCwdEfvvEo6D9HwpA8wzvmOJEqAg9ySu8g4x0Hb9hSB/BANEKJ+LbPBU0lzbAJs4xt1AoshKkUGQmiH8/jJ0gdhTTLmSegHlPE0oOdXALnqDjKYh3px//fSgSWG8UqfrrIICzYYSJXRr9BSPbpNzw7gBjKjKOYI7ReIGqQRIap5+5MdjyvuDkExvGeXSlONWZAP3/AZBwJohU7QJRGU+cTVH18ELmRPNBmibW6MT/k1b0XhdkRBvyT6SB6EYv/GvhSmRNpGngRULsAlxMCGNXp7w3FfdEbTEEDdLI9TdIKRUzUesa3I461ER8cpNT7gMRhpKmYVS9ELOgCUQsa4SsulciKiLbY+AnHD8cpuhISsnxpamI84sbDq9qYJgf8wiiOBrC7Ml7M7ZECCqKoiiKoiiKoiiKoijv5AvJxlZRyNWWLwAAAABJRU5ErkJggg==")
                    }
                    className="flex justify-center items-center w-[45px] h-[45px] bg-[#C4C4C4] rounded-full cursor-pointer"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="flex w-full flex-col items-start space-y-0 ml-2">
          <div className="w-full flex justify-between items-center">
            <h3 className="text-[#202020] font-light font-inter text-[13px] m-0">
              {task.patient_name}
            </h3>
            <div className="text-[#1D2951] font-light font-inter text-end text-[13px] ">
              #{task.patientid}
            </div>
          </div>
          <p className="text-xs font-inter text-[#A2A1A8] my-1">
            DOB :{" "}
            {new Date(dob).toLocaleDateString("en-US", {
              year: "numeric",
              month: "long",
              day: "numeric",
            })}
          </p>

          <p className="text-[#A2A1A8] font-inter text-xs m-0 text-start">
            {insuranceName && insuranceName.length > 14
              ? `${insuranceName.slice(0, 14)}...`
              : insuranceName}
          </p>
        </div>
      </div>
      <div className="w-full flex justify-between items-center">
        <button
          onClick={() =>
            task.ordertype === "Alerts" && handleAlertOpenModal(task.patientid)
          }
          className="rounded-lg py-1 px-4 font-roboto text-[11px] bg-[#50869A] text-white shadow-md max-w-[160px] truncate"
        >
          {task.ordertype.charAt(0).toUpperCase() + task.ordertype.slice(1)}
        </button>

        <div className="flex items-center gap-2">
          {
            task.status !== "COMPLETED" && task.status !== "CANCELLEDTASK" ? (
              <>
                {taskscreenprev.includes("Mark Completed") && (
                  <img
                    src={tick}
                    onClick={() => {
                      handleCompleteClick(task);
                    }}
                    className="w-6 h-6 cursor-pointer"
                    alt="Complete"
                  />
                )}
                {taskscreenprev.includes("Cancel Task") && (
                  <img
                    src={cancel}
                    onClick={() => {
                      handleCancelClick(task);
                    }}
                    className="w-7 h-7 cursor-pointer"
                    alt="Cancel"
                  />
                )}
              </>
            ) : (
              <></>
            )
            //      <span className="text-[#1D2951] text-xs font-inter flex items-end">
            //   <img src={DoctorF} className="mr-2" alt="$/" />
            //   {typeof task.completed_by === 'string'
            //     ? task.completed_by.charAt(0).toUpperCase() + task.completed_by.slice(1).toLowerCase()
            //     : ''}
            // </span>
          }
          <img
            onClick={openModal}
            src={task.order_notes ? addpdforange : addpdf}
            className="w-6 h-6 cursor-pointer"
            alt=""
          />
        </div>
      </div>
      <div className="w-full flex justify-between items-start">
        <div className="text-[#4B4B4B] text-[13px] font-light text-left w-[220px]">
          {task.ordername
            ? task.ordername.replace(/<[^>]*>/g, "")
            : `${task.tov} Level - ${task.lov}`}
        </div>
        {task.status === "COMPLETED" ? (
          <CheckIcon style={{ color: "#3cb371" }} />
        ) : (
          <div
            className={`w-4 h-4 rounded-full ${getOrderStatusColor(
              task.status
            )}`}
          ></div>
        )}{" "}
      </div>
      <div className="w-full flex justify-between mb-8">
        <p className="text-[#4B4B4B] font-extralight text-xs m-0 w-[160px] text-start">
          Ordered by : {task?.provider || ""}
        </p>
        <p className="text-[#4B4B4B] font-extralight text-xs m-0">
          {" "}
          {dayjs(task.ts).format("DD MMMM YYYY")}
        </p>
      </div>

      {task.status === "COMPLETED" || task.status === "CANCELLEDTASK" ? (
        <div className="flex text-sm gap-2 items-center text-normal mt-4">
          {humanicon}{" "}
          {task.completed_by.charAt(0).toUpperCase() +
            task.completed_by.slice(1).toLowerCase()}
        </div>
      ) : task.ordertype !== "Notes" ? (
        <div>
          <button
            onClick={() => {
              handleScheduleClick(task);
            }}
            className="absolute bottom-4 border-2 flex justify-center px-2 gap-2 bg-[#FAFAF9] text-[#979797] rounded-full text-sm shadow-md items-center"
          >
            <span>
              {scheduleStates[task.id] || task?.schedule === "t"
                ? "Schedule"
                : "Today"}
            </span>

            <Edit style={{ width: "13px" }} />
          </button>
        </div>
      ) : null}

      <div
        onClick={opentaskModal}
        className="absolute  bottom-0 right-0 bg-[#E1795426] w-[67px] h-[58px] flex items-center justify-center rounded-tl-[20px] "
        style={{ borderBottomRightRadius: "20%" }}
      >
        <div className="absolute bottom-0 right-0 bg-[#E1795426] w-[67px] h-[58px] flex items-center justify-center rounded-tl-[20px]">
          <div className="w-[30px] h-[30px] flex items-center justify-center border-[1.5px] border-[#E17954] rounded-full ">
            <span className="font-bold text-[16px] text-[#E17954]">
              {" "}
              {/* {task.orders.length} */ totalOrders.length}
            </span>
          </div>
        </div>
      </div>

      {/* { 
  (task.status === 'COMPLETED' || task.status === 'CANCELLEDTASK') &&
  <span className="text-[#1D2951] font-inter flex text-xs ">
    <img src={DoctorP} className="mr-2" alt="$/" /> {fullName}
  </span>
  } */}
      {openTasks && (
        <TasksModal
          setToastSeverity={setToastSeverity}
          setToastMessage={setToastMessage}
          setOpenToast={setOpenToast}
          handleconfirmScheduleClick={handleconfirmScheduleClick}
          scheduleStates={scheduleStates}
          closetaskModal={closetaskModal}
          handleScheduleClick={handleScheduleClick}
          task={totalOrders}
          markAsComplete={markAsComplete}
          markAscancel={markAscancel}
        />
      )}
      {/* New small button in the bottom left corner */}

      {isModalOpen &&
        (modalType === "add" ? (
          <Addnote trigger={trigger} closeModal={closeModal} task={task} />
        ) : (
          <Updatenote trigger={trigger} closeModal={closeModal} task={task} />
        ))}
      <ScheduleModal
        open={scheduleConfirmationOpen}
        onClose={closeScheduleConfirmationModal}
        onConfirm={handleconfirmScheduleClick}
        order={selectedOrder}
      />
      <ToastMessage
        message={toastMessage}
        severity={toastSeverity}
        open={openToast}
        handleClose={handleToastClose}
      />
      {isAlertModal && (
        <Alertsgraphs
          PatientID={selectedAlert}
          isAlert={true}
          onClose={handleAlertCloseModal}
        />
      )}
    </div>
  );
};

export default MiniCards;
